<div class="col-xs-6 col-sm-7 col-xl-8 d-flex align-items-center">
  <section #pickerParentRef>
    <div class="color-square" [style.background]="value"></div>
    <input
      class="form-control color-input"
      (click)="isPickerOpen = true"
      [type]="type"
      [value]="value"
      (blur)="onblur()"
    />
  </section>
</div>

<ion-modal
  class="popover-modal"
  [keyboardClose]="false"
  [isOpen]="isPickerOpen"
  [showBackdrop]="false"
  [animated]="false"
  (didDismiss)="isPickerOpen = false"
  (willPresent)="calculateActualContentPosition()"
  (click)="isPickerOpen = false"
>
  <ng-template>
    <div
      class="popover-modal-content border-border background-background"
      [style.overflow]="'hidden'"
      [style.left.px]="pickerLeft"
      [style.top.px]="pickerTop"
      [style.width.px]="pickerWidth"
      [class.no-top-pos]="pickerTop === 0"
      [class.inverted]="pickerInverted"
      (click)="noBubble($event)"
    >
      <input
        [hidden]="true"
        [(colorPicker)]="value"
        (colorPickerChange)="onChange($event)"
        [cpToggle]="true"
        [cpDialogDisplay]="'inline'"
        [cpWidth]="pickerWidth + 'px'"
        [cpHeight]="pickerHeight + 'px'"
        [cpAlphaChannel]="'disabled'"
      />
    </div>
  </ng-template>
</ion-modal>

